interface PartnerizeTrackingLinkOptions {
  baseUrl: string;
  camRef: string;
  pubRef?: string;
  adRef?: string;
  creativeRef?: string;
  destination?: string;
}

function getPartnerizeTrackingLink({
  baseUrl,
  camRef,
  pubRef,
  adRef,
  creativeRef,
  destination,
}: PartnerizeTrackingLinkOptions) {
  if (baseUrl && camRef) {
    const camRefPath = `/camref:${camRef}`;
    const pubRefPath = pubRef ? `/pubref:${pubRef}` : '';
    const adRefPath = adRef ? `/adref:${adRef}` : '';
    const creativeRefPath = creativeRef ? `/creativeref:${creativeRef}` : '';
    const destinationPath = destination ? `/destination:${destination}` : '';

    return `${baseUrl}${camRefPath}${pubRefPath}${adRefPath}${creativeRefPath}${destinationPath}`;
  }
}

export { getPartnerizeTrackingLink };
